import {useState} from "react";
import {useSelector} from "react-redux";
import {t} from "i18next";

import Divider from "../../utilities/Divider/Divider";
import {TextAreaInput} from "../Inputs";
import NewPdfViewer from "../Project/Documents/DocumentView/NewPdfViewer";

import {DevItTable} from "./DevITBodyTable";
import DevITForm from "./DevITForm";
import {selectDevITTicket} from "./DevITSlice";

const DevITBody = ({onPaginate, page}) => {
  const currentTicket = useSelector(selectDevITTicket);
  const [currentTicketId, setCurrentTicketId] = useState(null);
  const orderedFiles = currentTicket?.files ? [...currentTicket.files].reverse() : [];
  const fileArray = orderedFiles.map(({fileUrl}) => fileUrl);
  const files = currentTicket?.files ?? [];

  return (
    <div className="grid2ColFirstBigger fGrow gap w100 mt0_5" style={{gridTemplateColumns: "minmax(0, 1fr) 30%"}}>
      <div className="fcCol gap0_5 w100">
        <DevITForm
          files={files}
          setCurrentTicketId={setCurrentTicketId}
          currentTicketId={currentTicketId}
          fileArray={fileArray}
        />
        <Divider />
        <DevItTable
          currentTicketId={currentTicketId}
          setCurrentTicketId={setCurrentTicketId}
          onPaginate={onPaginate}
          page={page}
        />
        <TextAreaInput name="itNote" placeholder={t("IT note")} height="minmax(5rem, 8rem)" readOnly />
      </div>
      <div className="kpPreview__box pdfViewerContain w100 h100">
        <NewPdfViewer fileArray={fileArray ?? []} />
      </div>
    </div>
  );
};

export default DevITBody;
